import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Content from './Content';

const ContentWithContext = (props) => {
  const {
    setPageContentCollection,
    refreshPageContentCollection,
  } = usePageContentContext();

  return <Content {...props} setCollection={setPageContentCollection} refreshCollection={refreshPageContentCollection} />;
};

export default ContentWithContext;
